<h1 mat-dialog-title>{{ generalMessage?.message }}</h1>
<div mat-dialog-content>
    <b>Please Contact Support</b>
</div>
<div mat-dialog-actions>
    <a href="/" mat-raised-button color="primary" cdkFocusInitial>Go To Device Menu</a>
</div>